import { createSlice} from '@reduxjs/toolkit';

const initialState = {
  user: null,
  data: [],
  pickedItem: null,
  hayNotificaciones: false,
};

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    setNotifications: (state, action) => {
      state.data = action.payload;
    },
    deleteNotification: (state, action) => {
      state.data = state.data.filter(item => item.id_alerta !== action.payload);
      state.pickedItem = null;
    },
    setPickedNotification: (state, action) => {
      state.pickedItem = state.data.find(item => item.id_alerta === action.payload);
    },
    setHayNotificaciones: (state, action) => {
      state.hayNotificaciones = action.payload;
    }
  },
});

export const {setNotifications, deleteNotification, setPickedNotification, setHayNotificaciones} = notificationsSlice.actions;
export const selectNotifications = (state) => state.notifications.data;
export const selectedNotification = (state) => state.notifications.pickedItem;
export const selectHayNotificaciones = (state) => state.notifications.hayNotificaciones;

export default notificationsSlice.reducer;